module.exports = __webpack_public_path__ + "static/media/simulationandtrain.a03df832.png";